import Link from 'next/link'
import { useTrans } from 'hooks'

function BoxCatalogo({
  title = '',
  description = '',
  primaryCta = '',
  primaryHref = '/',
  primaryBlank = false,
  secondaryCta = '',
  secondaryHref = '/',
  secondaryBlank = false,
  imgHref,
}) {
  const t = useTrans()

  return (
    <article className="box-catalogo">
      <div className="box-catalogo__head">
        <div className="box-catalogo__head__title">{t(title)}</div>
        <div className="box-catalogo__head__description">{t(description)}</div>
        <div className="box-catalogo__head__cta-box">
          <Link legacyBehavior href={primaryHref}>
            <a className="button button--primary" target={primaryBlank ? '_blank' : null}>
              {t(primaryCta)}
            </a>
          </Link>
          <Link legacyBehavior href={secondaryHref}>
            <a className="button button--secondary" target={secondaryBlank ? '_blank' : null}>
              {t(secondaryCta)}
            </a>
          </Link>
        </div>
      </div>
      {imgHref && <img className="box-catalogo__image" src={imgHref} />}
    </article>
  )
}

export default BoxCatalogo
